<template>
  <div id="email-template">
    <dash-header :pages="breadCrumbsPages" :dashboardTitle="$route.params.templateId | removeKebabCase"/>
    <a-layout id="components-layout-demo-custom-trigger">
      <dash-sidebar
        defaultSelectedKeys="5"
        :menuItems="commonMenuItems.admin"
      />
      <a-layout>
        <a-layout-content
          :style="{ margin: '24px 16px', padding: '24px', background: '#fff', minHeight: '280px' }"
        >
          <a-alert type="info" style="margin-bottom: 20px;">
            <p slot="description">
              Please leave texts inside <span style="color: red; font-weight: bold;">"{[ ]}"</span> intact.
            </p>
          </a-alert>
          <a-form :form="emailTemplateForm" @submit="handleSubmit">
            <a-form-item label="Subject" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
              <a-input
                v-decorator="['subject',  { initialValue: '', rules: [{ required: true, message: 'Please enter subject line.' }] }]"
              />
            </a-form-item>
            <a-form-item label="Body" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
              <a-textarea
                placeholder="Body"
                :rows="10"
                v-decorator="[ 'emailBody', { initialValue: '', rules: [{required: true, message: 'Please enter body for the email.' }] }]"
              />
            </a-form-item>
            <a-form-item label="Salutation" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
              <a-textarea
                placeholder="Salutation"
                :rows="4"
                v-decorator="[ 'salutation', { initialValue: '', rules: [{required: true, message: 'Please enter salutation for the email.' }] }]"
              />
            </a-form-item>
            <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
              <a-button type="primary" html-type="submit">
                Save
              </a-button>
            </a-form-item>
          </a-form>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import dashHeader from '@src/views/dashboard/Header.vue';
import dashSidebar from '@src/views/dashboard/Sidebar.vue';

export default {
  name: 'email-template',
  data() {
    return {
      breadCrumbsPages: [
        {
          name: 'Home',
          route: '/',
        },
        {
          name: 'Dashboard',
          route: '/dashboard',
        },
        {
          name: 'Email Notifications',
          route: '/dashboard/email-notifications',
        },
        {
          name: `${(this.$route.params.templateId).replace(/-/g, ' ')}`,
          route: `/dashboard/email-notifications/${this.$route.params.templateId}`,
        },
      ],
      formLayout: 'horizontal',
    };
  },
  components: {
    dashHeader,
    dashSidebar,
  },
  created() {
    this.emailTemplateForm = this.$form.createForm(this, {
      name: 'email-template',
      onFieldsChange: (_, changedFields) => {
        this.$emit('change', changedFields);
      },
      mapPropsToFields: () => ({
        subject: this.$form.createFormField({
          value: this.subject,
        }),
        emailBody: this.$form.createFormField({
          value: this.emailBody,
        }),
        salutation: this.$form.createFormField({
          value: this.salutation,
        }),
      }),
    });
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.emailTemplateForm.validateFields((err, values) => {
        if (!err) {
          const formValues = { ...values, ...{ templateId: this.$route.params.templateId, userToken: this.userToken } };
          this.updateEmailTemplate(formValues);
        }
      });
    },
    ...mapActions('telasAdmin', {
      updateEmailTemplate: 'updateEmailTemplate',
      getEmailTemplate: 'getEmailTemplate',
    }),
  },
  computed: {
    ...mapGetters('user', {
      userToken: 'getUserToken',
    }),
    ...mapState('telasAdmin', {
      emailTemplate: state => state.emailTemplate,
    }),
    subject() {
      return this.emailTemplate.subject ? this.emailTemplate.subject : '';
    },
    emailBody() {
      return this.emailTemplate.emailBody ? this.$options.filters.removeEntities(this.emailTemplate.emailBody) : '';
    },
    salutation() {
      return this.emailTemplate.salutation ? this.$options.filters.removeEntities(this.emailTemplate.salutation) : '';
    },
  },
  mounted() {
    this.getEmailTemplate({ templateId: this.$route.params.templateId, userToken: this.userToken });
  },
  watch: {
    subject(val) {
      return this.emailTemplateForm.setFieldsValue({ subject: val });
    },
    emailBody(val) {
      return this.emailTemplateForm.setFieldsValue({ emailBody: val });
    },
    salutation(val) {
      return this.emailTemplateForm.setFieldsValue({ salutation: val });
    },
  },
};
</script>
